import clsx from "clsx";
import React, { FC } from "react";

import { Icon } from "../../../icon";
import { FormFieldMessageProps, FormFieldStatus } from "./types";

export const FormFieldMessage: FC<FormFieldMessageProps> = ({
  message,
  status = FormFieldStatus.Info,
}) => {
  return (
    <div
      className={clsx(
        "border rounded px-[6px] mt-1 text-xs flex items-start gap-2 select-none",
        message ? "visible" : "invisible",
        status === FormFieldStatus.Error && "text-error-dark bg-error-light border-error",
        status === FormFieldStatus.Warning && "text-warning-dark bg-warning-light border-warning",
        status === FormFieldStatus.Info && "text-info-dark bg-info-light border-info",
        status === FormFieldStatus.Success && "text-success-dark bg-success-light border-success"
      )}
    >
      <Icon icon="info" className="w-4 text-inherit flex-none inline" />
      <span className="py-1">{message}&nbsp;</span>
    </div>
  );
};
